import React, {Component} from 'react'
import {connect } from 'react-redux'
import '../../assets/css/requisition.css'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import PropTypes from 'prop-types'
import {
    withCookies
} from 'react-cookie'
import { 
    withStyles,
    FormControl,
    FormLabel,
    Typography,
    Button
} from '@material-ui/core';
import {
    Redirect
} from 'react-router-dom'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import {
    getCvDetail,
    getCvDetailWithCookies
} from '../../actions/CvActions'
import * as Sentry from '@sentry/browser'

import {
    NavLink,
} from 'react-router-dom'
import {
    ROUTE_ADMIN_CV_DETAIL,
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_ADMIN_CREATE_JOB
} from '../../utils/routes'
import {
    logout
} from '../../actions/LoginAction'
import InformationDialog from '../../components/Dialog/InformationDialog'
import {
    JWT
} from '../../utils/CommonConstant'

Sentry.init({
    dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class CvDetail extends Component {

    constructor() {
        super();
        this.state = {
          open: false
        }
    }

    componentWillMount() {

        const {match: {params}} = this.props
        this.props.getCvDetailWithCookies(params.id, this.props.cookies.cookies.jwt === undefined ? sessionStorage.getItem(JWT):this.props.cookies.cookies.jwt)

    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }

    render() {

        const {classes, cv_detail: {detail, unauthorize}} = this.props

        if(unauthorize) {
            return (
                <Redirect from={ROUTE_ADMIN_CV_DETAIL} to={ROUTE_ADMIN_LOGIN}/>
            )
        }

        return (
            <div>
                <div className={classes.main}>
                    <div className="Content">

                    <InformationDialog
                        open={this.state.open}
                        handleClose={this.handleClose}
                        handleLogout={this.handleLogout}
                    />

                    <div className="CvBtn">

                        <NavLink from={ROUTE_ADMIN_CV_DETAIL} to={ROUTE_REQUISITION_LIST}>
                            <Button  variant="outlined" className={classes.nav_button} color="secondary">
                                View Requisitions
                            </Button>
                        </NavLink>

                        <NavLink  from={ROUTE_ADMIN_CV_DETAIL} to={ROUTE_ADMIN_JOB}>
                            <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                View Jobs
                            </Button>
                        </NavLink>
                        <NavLink  from={ROUTE_ADMIN_CV_DETAIL} to={ROUTE_ADMIN_CREATE_JOB}>
                            <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                Create Job
                            </Button>
                        </NavLink>

                        <NavLink from={ROUTE_ADMIN_CV_DETAIL} to={ROUTE_ADMIN_CV}>
                            <Button variant="outlined" className={classes.nav_button} color="secondary">
                                View CVs
                            </Button>
                        </NavLink>

                        <Button 
                            onClick={() => this.onLogout()}
                            variant="outlined" 
                            className={classes.nav_button} 
                            color="secondary">
                            Logout
                        </Button>
                    </div>

                        <h4 className="Employee-Requisition-Form">
                            CV Detail
                        </h4>
                        <GridContainer>
                            <GridItem  xs={12} sm={12} md={6}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Name
                                    </FormLabel>
                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                        { detail.full_name }
                                    </Typography>
                                </FormControl>
                            </GridItem>
                            <GridItem  xs={12} sm={12} md={6}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Email
                                    </FormLabel>
                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                        { detail.email }
                                    </Typography>              
                                </FormControl>
                            </GridItem>

                            <GridItem  xs={12} sm={12} md={6}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Current Job
                                    </FormLabel>
                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                        { detail.current_job }
                                    </Typography>
                                </FormControl>
                            </GridItem>
                            <GridItem  xs={12} sm={12} md={6}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Status
                                    </FormLabel>
                                    
                                        <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                           {
                                               detail.status
                                           }
                                        </Typography>   
                                    
                                               
                                </FormControl>
                            </GridItem>
                            <GridItem  xs={12} sm={12} md={6}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Yoma Employee
                                    </FormLabel>
                                    
                                        <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                           {
                                               detail.yoma_employee ? ("Yes"):("No")
                                           }
                                        </Typography>     
                                </FormControl>
                            </GridItem>

                            {/* <GridItem  xs={12} sm={12} md={12}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        Cover Letter
                                    </FormLabel>
                                    
                                        <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                           {
                                               detail.cover_letter
                                           }
                                        </Typography>   
                                    
                                               
                                </FormControl>
                            </GridItem> */}

                            <GridItem  xs={12} sm={12} md={12}>
                                <FormControl className={classes.item} component="fieldset">
                                    <FormLabel>
                                        CV URL
                                    </FormLabel>
                                    {
                                        detail.cvs !== undefined && (
                                            detail.cvs.map((url, key) => 
                                            <Typography 
                                                className={classes.itemValue} 
                                                variant="h6" 
                                                gutterBottom
                                                key={key}>
                                                <a href={`${url}`}>
                                                    {`View CV ${key+1}`}
                                                </a>
                                            </Typography>
                                            )
                                        )
                                        
                                    }
                                             
                                </FormControl>
                            </GridItem>

                            
                        </GridContainer>

                    </div>
                </div>
            </div>
        )
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
      //  this.props.history.push(ROUTE_ADMIN_LOGIN);

    }

}

CvDetail.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch) => ({
    getCvDetail: (id) => {
        dispatch(
            getCvDetail(id)
        )
    },
    getCvDetailWithCookies: (cv_id, jwt) => {
        dispatch(
            getCvDetailWithCookies(cv_id, jwt)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
})
  
const mapStateToProps = (state, ownProps) => ({
    cv_detail: state.cvs,
    ownProps: ownProps.cookies
})


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(requisitionStyle)(withCookies(CvDetail)))